import { render, staticRenderFns } from "./BusCivil.vue?vue&type=template&id=dfcc57e0&"
import script from "./BusCivil.vue?vue&type=script&lang=js&"
export * from "./BusCivil.vue?vue&type=script&lang=js&"
import style0 from "./BusCivil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports